import { render, staticRenderFns } from "./Stake.vue?vue&type=template&id=02f23e3c&scoped=true&"
import script from "./Stake.vue?vue&type=script&lang=js&"
export * from "./Stake.vue?vue&type=script&lang=js&"
import style0 from "./Stake.vue?vue&type=style&index=0&id=02f23e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f23e3c",
  null
  
)

export default component.exports